import React, { useId, useRef } from 'react';
import { StepCard } from '../../molecules';
import { Container, EntryAnimation, Heading } from '../../atoms';
export default function StepListSection(param) {
    var title = param.title, cards = param.cards, className = param.className;
    var id = useId();
    var containerRef = useRef(null);
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: StepListSection.name,
        className: className
    }, /*#__PURE__*/ React.createElement("div", null, !!title && /*#__PURE__*/ React.createElement("div", {
        className: "mb-6 md:mb-8"
    }, /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3"
    }, title))), /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-6 grid-cols-1 grid-flow-row auto-rows-max md:gap-7 md:grid-cols-3"
    }, cards.map(function(card, cardIndex) {
        return /*#__PURE__*/ React.createElement(EntryAnimation, {
            key: "card-".concat(id, "-").concat(card.title),
            delay: cardIndex / 10
        }, /*#__PURE__*/ React.createElement(StepCard, card));
    }))));
}

//# sourceMappingURL=StepListSection.js.map